<template>
  <div class='special-account-component'>
    <div>
      <button class='button is-info' @click='editAccount(-1)'>新增</button>
    </div>
    <div class='table-wrap'>
      <table class="table is-bordered">
        <thead>
          <tr>
            <th>userid</th>
            <th>账号名</th>
            <th>手机号</th>
            <th>备注</th>
            <th>当前状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr class="list-cell" v-for="(item,index) in list">
            <td>{{item.userId}}</td>
            <td>{{item.username}}</td>
            <td>{{item.phoneNumber}}</td>
            <td>{{item.remark}}</td>
            <td>{{item.status ? '关闭': '开启'}}</td>
            <td>
              <button class='button is-danger' @click='deleteAccount(index)'>删除</button>
              <button class='button is-primary' @click='editAccount(index)'>编辑</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
     <el-dialog :title="modal.title" :visible.sync="modal.visible" >
       <div class='modal-wrap'>
         <div class='control input-wrap'>
          <label for="userId">用户id:</label>
          <input class='input' type="text" v-model='modal.userId'>
         </div>
         <div class='control input-wrap'>
          <label for="status">是否开启:</label>
          <input class='radio' type="radio" name='status' v-model='modal.status' value='1'>关闭
          <input class='radio' type="radio" name='status' v-model='modal.status' value='0'>开启
         </div>
         <div class='control input-wrap'>
          <label for="userId">备注:</label>
          <input class='input' type="text" v-model='modal.remark'>
         </div>
       </div>
       <div slot="footer" class="dialog-footer">
         <el-button @click="dialogFormVisible(false)">取 消</el-button>
         <el-button type="primary" @click="dialogFormVisible(true)">确 定</el-button>
       </div>
     </el-dialog>
  </div>
</template>

<script type="text/babel">
  export default {
    data() {
      return {
        list: [],
        currentIndex: -1,
        modal: {
          title: '',
          visible: false,
          userId: '',
          status: 1,
          remark: '',
        },
      }
    },
    mounted:function () {
      this.$nextTick(function () {
        this.getSpecialAccount()
      })
    },
    methods: {
      deleteAccount(index) {
        if (confirm('确定删除?')) {
          HttpRequest.get('/admin.php?method=fashion.deleteSpecialAccount', {userId: this.list[index].userId})
          this.list.splice(index, 1)
        }
      },
      editAccount(index = -1) {
        this.currentIndex = index
        if (index == -1) {
          this.modal = {
            title: '新增特殊账号',
            visible: true,
            userId: '',
            status: 1,
            remark: ''
          }
        } else {
          this.modal = {
            title: '编辑特殊账号',
            visible: true,
            userId: this.list[index].userId,
            status: this.list[index].status,
            remark: this.list[index].remark
          }
        }
      },
      getSpecialAccount() {
        HttpRequest.get('/admin.php?method=fashion.getSpecialAccountList').then((response) => {
          if (response && response.data && response.data.list) {
            this.list = response.data.list
          }
        })
      },
      doSaveSpecialAccount() {
        let params = {
          userId: this.modal.userId,
          status: this.modal.status,
          remark: this.modal.remark
        }
        HttpRequest.post('/admin.php?method=fashion.doSaveSpecialAccount', params).then((response) => {
          if (response && response.data && response.data.success) {
            if (this.currentIndex == -1) {
              this.list.push({userId: this.modal.userId, status: this.modal.status})
            } else {
              this.list[this.currentIndex].userId = this.modal.userId
              this.list[this.currentIndex].status = this.modal.status
            }
            this.getSpecialAccount()
            this.modal.visible = false
          } else if (response && response.data && response.data.msg) {
            this.$message(response.data.msg)
          }
        })
      },
      dialogFormVisible(bool){
        if(bool){
          this.doSaveSpecialAccount()
        }
        this.modal.visible = false;
      }
    }
  }
</script>

<style lang="less" scoped>
  .button-record {
    margin-left: 10px;
  }
  .table-wrap {
    margin-top: 20px;
  }
  table td {
    text-align: center;
  }
  .modal-wrap {
    margin-left: 75px;
  }
  .input-wrap {
    display: flex;
    width: 400px;
    label {
      width: 80px;
    }
    .radio {
      margin-top: 3px;
    }
  }
</style>
